import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { InvoiceService } from '../_services/invoice.service';
import { BuildingService } from 'app/_services/building.service';
import { TokenStorageService } from '../_services/token-storage.service';
import flatpickr from "flatpickr";

@Component({
  selector: 'app-invoice',
  templateUrl: './add-invoice.component.html',
  styleUrls: ['./invoices.component.scss']
})
export class AddInvoiceComponent implements OnInit {
  roofTypesList: any = [];
  roofAccessList: any = [];
  buildingTypesList: any = [];
/*
  addSubmissionForm: FormGroup = new FormGroup({
    submission_no: new FormControl(""),
    purchase_date: new FormControl(""),
    build_date: new FormControl(""),
    address: new FormControl(""),
    address2: new FormControl(""),
    city: new FormControl(""),
    province: new FormControl(""),
    country: new FormControl(""),
    postalcode: new FormControl(""),
    roof_type_id: new FormControl(""),
    roof_description: new FormControl(""),
    roof_access: new FormControl(""),
    roof_date: new FormControl(""),
    building_type_id: new FormControl(""),
    owner_since: new FormControl(""),
    water_infiltration: new FormControl(""),
    description: new FormControl(""),
  })
*/
  constructor(
    private tokenStorage: TokenStorageService,
    private activatedRoute: ActivatedRoute,
    private invoices: InvoiceService,
    private buildings: BuildingService
  ) { }

  ngOnInit(): void {
    const contactUUID = this.tokenStorage.getToken() || "";

    /*
    this.invoices.getRoofTypes$(contactUUID).subscribe((data) => {
      this.roofTypesList = data;
    });
    
    this.buildings.getBuildingTypes$(contactUUID).subscribe((data) => {
      this.buildingTypesList = data;
    });
*/
    flatpickr(".date", {
      altInput: false,
      altFormat: "F j, Y",
      ariaDateFormat: "Y-m-d",
      dateFormat: "Y-m-d"
    });
  }
/*
  openCalendar(e: any): void {
    console.log(e)
  }

  onSubmit(value: any): void {
    const contactUUID = this.tokenStorage.getToken() || "";
    const account = this.tokenStorage.getUser() || "";
    const clientid = this.activatedRoute.snapshot.params['clientid'];

    console.log("Form values ", value)

    let submissionInfos: any = {
      submission_no: this.addSubmissionForm.get("submission_no")!.value,

      address: this.addSubmissionForm.get("address")!.value,
      address2: this.addSubmissionForm.get("address2")!.value,
      city: this.addSubmissionForm.get("city")!.value,
      province: this.addSubmissionForm.get("province")!.value,
      postalcode: this.addSubmissionForm.get("postalcode")!.value,
      country: this.addSubmissionForm.get("country")!.value,
      
      roof_type_id: Number(this.addSubmissionForm.get("roof_type_id")!.value),
      roof_access: this.addSubmissionForm.get("roof_access")!.value,
      roof_description: this.addSubmissionForm.get("roof_description")!.value,

      building_type_id: this.addSubmissionForm.get("building_type_id")!.value,
      water_infiltration: this.addSubmissionForm.get("water_infiltration")!.value,
      description: this.addSubmissionForm.get("description")!.value,

      roof_date: this.addSubmissionForm.get("build_date")!.value,
      build_date: this.addSubmissionForm.get("build_date")!.value,
      purchase_date: this.addSubmissionForm.get("purchase_date")!.value,

      client_id: clientid,
      sales_account_id: account.account_id,
      
      is_new: true,
      active: true,
    };

    console.log('adding invoice ');

    this.invoice.addInvoice$(contactUUID, invoiceInfos).subscribe({
      next: data => {
        console.log("Data --> ", data)
      },
      error: err => {
        console.log("Something went wrong: ", err)
      }
    });
  }
  */
}
